import { Utility } from "src/helpers/utility";

/**
 * Activate the current brand's theme.
 *
 * Sets `data-brand` on <html>, which selects the matching
 * `[data-brand="<id>"]` block in src/css/brand.css. Tailwind's brand-color
 * tokens read those CSS variables via `var(--x)`, so this single attribute
 * swaps the whole palette with no per-component branching.
 *
 * Must run before the first React render (called from src/index.js) so the
 * initial paint already carries the brand colors — no flash. It is DOM-only and
 * URL-driven, so it is safe to call before the Redux store hydrates.
 */
export function applyBrandTheme() {
  if (typeof document === "undefined" || !document.documentElement) {
    return;
  }

  document.documentElement.dataset.brand = Utility.getBrandId();
}
